import {MetricsSection} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import EstimatedVolumeItem from './EstimatedVolumeItem';

export function getEstimatedVolumeItem({
  currentUserCompetency,
  metrics,
  tt,
}: any) {
  const estimatedVolumeItem = {
    value: metrics.estimatedVolume,
    component: EstimatedVolumeItem,
  };

  if (
    currentUserCompetency === COACH ||
    currentUserCompetency === BUSINESS_COACH ||
    currentUserCompetency === BUSINESS_LEADER
  ) {
    // @ts-expect-error TS(2339): Property 'testID' does not exist on type '{ value:... Remove this comment to see the full error message
    estimatedVolumeItem.testID =
      MetricsSection.metricProjectedTotalGenerationVolume;
    // @ts-expect-error TS(2339): Property 'label' does not exist on type '{ value: ... Remove this comment to see the full error message
    estimatedVolumeItem.label = tt(
      'estimated.org',
      'Projected Total Generation Volume',
    );
  }
  return estimatedVolumeItem;
}
